export const CAL_BOOKING_PATH = "mind-media/quick-intro-call";

export type CalPrefill = {
  name?: string;
  email?: string;
  phone?: string;
  website?: string;
  instagram_handle?: string;
  challenge?: string;
};

export function isPhoneViewport() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 767px)").matches;
}

/**
 * Mobile browsers (especially iOS Chrome/Safari) render the Cal.com iframe modal
 * cropped behind the sticky header. On phones we send users to the full-page
 * Cal.com booking flow with the same prefill data instead.
 */
export function openCalFullPage(data: CalPrefill) {
  const url = new URL(`https://cal.com/${CAL_BOOKING_PATH}`);
  const params: Record<string, string | undefined> = {
    name: data.name,
    email: data.email,
    attendeePhoneNumber: data.phone,
    Website: data.website,
    Instagram: data.instagram_handle,
    notes: data.challenge ? `Challenge: ${data.challenge}` : undefined,
    theme: "light",
    layout: "mobile",
  };
  for (const [k, v] of Object.entries(params)) {
    if (v) url.searchParams.set(k, v);
  }
  window.location.href = url.toString();
}
